/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVehicleOn56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <g fill='currentColor'>
        <path d='M50.75 28a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z' />
        <path
          fillRule='evenodd'
          d='M16.562 28c0 3.206-2.226 5.25-5.656 5.25-3.43 0-5.656-2.044-5.656-5.25s2.226-5.25 5.656-5.25c3.43 0 5.656 2.044 5.656 5.25zm-8.694 0c0 2.03 1.176 3.318 3.038 3.318 1.862 0 3.038-1.274 3.038-3.318s-1.176-3.318-3.038-3.318c-1.862 0-3.038 1.274-3.038 3.318z'
        />
        <path d='M20.362 32.97h-2.296v-9.94h2.744l4.13 5.698c.266.392.518.84.672 1.204h.028V23.03h2.296v9.94h-2.604l-4.284-5.768c-.238-.378-.518-.826-.658-1.162h-.042c.014.42.014.854.014 1.33v5.6z' />
        <path
          fillRule='evenodd'
          d='M10.5 17.5C4.701 17.5 0 22.201 0 28s4.701 10.5 10.5 10.5h35C51.299 38.5 56 33.799 56 28s-4.701-10.5-10.5-10.5h-35zm35 1.5h-35a9 9 0 100 18h35a9 9 0 100-18z'
        />
      </g>
      <defs>
        <clipPath id='vehicle-on-56_svg__clip0'>
          <path fill='#fff' d='M0 0h56v56H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgVehicleOn56;
